<template>
  <div>
    <div class="row">
      <!-- <div v-for="(data, id) in data" :key="id" class="col-12">
        <div class="card card_grey mb_12">
          <div class="sub_title_2 m-b-20">{{ data.metricName }}</div>
          <div class="d-flex align-items-center">
            <div class="data_text">{{ data.value }} {{ data.unit }}</div>
            <div class="d-flex ms-2">
              <div
                class="d-inline-flex align-items-center"
                :class="
                  data.achievementStatus == 'UP' ? 'badge_green' : 'badge_red'
                "
              >
                <IconSvg
                  :color="data.achievementStatus == 'UP' ? 'green' : 'red'"
                  :type="
                    data.achievementStatus == 'UP' ? 'chart_up' : 'chart_down'
                  "
                />
                <div
                  class="data_detil"
                  :class="
                    data.achievementStatus == 'UP' ? 'text_green' : 'text_red'
                  "
                >
                  <span v-if="data.achievementStatus == 'UP'">+</span
                  >{{ data.achievement }}%
                </div>
              </div>
              <div
                class="d-inline-flex align-items-center me-2"
                :class="data.trendStatus == 'UP' ? 'badge_green' : 'badge_red'"
              >
                <IconSvg
                  :color="data.trendStatus == 'UP' ? 'green' : 'red'"
                  :type="data.trendStatus == 'UP' ? 'arrow_up' : 'arrow_down'"
                />
                <div
                  class="data_detil"
                  :class="data.trendStatus == 'UP' ? 'text_green' : 'text_red'"
                >
                  <span v-if="data.trendStatus == 'UP'">+</span
                  >{{ data.trend }}%
                </div>
              </div>
              <div>
                <button class="naked_button" @click="onShowModalOCR(data)">
                  <img src="@/assets/images/a/chart_icon.svg" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div v-for="(data, id) in data" :key="id" class="col-12">
        <div class="card card_grey mb_12">
          <div class="sub_title_2 m-b-20">{{ data.metricName }}</div>
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <div class="data_text">{{ data.value }} {{ data.unit }}</div>
              <div class="d-flex ms-2">
                <div
                  class="d-inline-flex align-items-center me-2"
                  :class="
                    data.trendStatus == 'UP' ? 'badge_green' : 'badge_red'
                  "
                >
                  <IconSvg
                    :color="data.trendStatus == 'UP' ? 'green' : 'red'"
                    :type="data.trendStatus == 'UP' ? 'arrow_up' : 'arrow_down'"
                  />
                  <div
                    class="data_detil"
                    :class="
                      data.trendStatus == 'UP' ? 'text_green' : 'text_red'
                    "
                  >
                    <span v-if="data.trendStatus == 'UP'">+</span
                    >{{ data.trend }}%
                  </div>
                </div>
                <div
                  class="d-inline-flex align-items-center"
                  :class="
                    data.achievementStatus == 'UP' ? 'badge_green' : 'badge_red'
                  "
                >
                  <IconSvg
                    :color="data.achievementStatus == 'UP' ? 'green' : 'red'"
                    :type="
                      data.achievementStatus == 'UP' ? 'chart_up' : 'chart_down'
                    "
                  />
                  <div
                    class="data_detil"
                    :class="
                      data.achievementStatus == 'UP' ? 'text_green' : 'text_red'
                    "
                  >
                    <span v-if="data.achievementStatus == 'UP'">+</span
                    >{{ data.achievement }}%
                  </div>
                </div>
              </div>
            </div>
            <div>
              <button
                v-if="data.metricId === 'HC_ORGANISATIONAL_OCR'"
                class="naked_button"
                @click="onShowModalOCR(data)"
              >
                <img src="@/assets/images/a/chart_icon.svg" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- <div v-if="data.ohai_name !== ''" class="col-12">
        <div class="card card_grey">
          <div class="sub_title_2 m-b-20">
            {{ data.ohai_name }}
          </div>
          <div class="d-flex align-items-center">
            <div class="data_text">{{ data.ohai_value }}</div>
            <div class="d-flex ms-2">
              <div
                class="d-inline-flex align-items-center me-2"
                :class="
                  data.ohai_trend_status == 'UP' ? 'badge_green' : 'badge_red'
                "
              >
                <IconSvg
                  :color="data.ohai_trend_status == 'UP' ? 'green' : 'red'"
                  :type="
                    data.ohai_trend_status == 'UP' ? 'arrow_up' : 'arrow_down'
                  "
                />
                <div
                  class="data_detil"
                  :class="
                    data.ohai_trend_status == 'UP' ? 'text_green' : 'text_red'
                  "
                >
                  <span v-if="data.ohai_trend_status == 'UP'">+</span
                  >{{ data.ohai_trend }}%
                </div>
              </div>
              <div
                class="d-inline-flex align-items-center"
                :class="
                  data.ohai_achievement_status == 'UP'
                    ? 'badge_green'
                    : 'badge_red'
                "
              >
                <IconSvg
                  :color="
                    data.ohai_achievement_status == 'UP' ? 'green' : 'red'
                  "
                  :type="
                    data.ohai_achievement_status == 'UP'
                      ? 'chart_up'
                      : 'chart_down'
                  "
                />
                <div
                  class="data_detil"
                  :class="
                    data.ohai_achievement_status == 'UP'
                      ? 'text_green'
                      : 'text_red'
                  "
                >
                  <span v-if="data.ohai_achievement_status == 'UP'">+</span
                  >{{ data.ohai_achievement }}%
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import IconSvg from "@/components/IconSvg.vue";
import LegalService from "@/services/legal/legal";

const apiLegal = LegalService.build();

export default {
  props: ["load", "data"],
  components: {
    IconSvg,
  },

  data() {
    return {
      dataOcr: {},
      modalOCR: {
        show: false,
        load: false,
      },
    };
  },

  methods: {
    onShowModalOCR(data) {
      this.dataOcr = data;
      this.modalOCR.show = true;
    },
    onCloseModalOCR(value) {
      this.modalOCR.show = value;
    },
  },
};
</script>
